/* eslint-disable prefer-const */
import React, { useState, useEffect } from 'react'
import { Dialog, makeStyles, DialogTitle, Grid, DialogContent, List, DialogActions, Button, ListItem } from '@material-ui/core'
import { magiContants } from 'utils/contants'

const useStyles = makeStyles(theme => ({
    dialogTitle: {
        backgroundColor: '#133e80',
        padding: '8px',
    },
    title: {
        color: '#ffffff',
        fontSize: '22px',
        fontWeight: 'bold',
    },
    dialogContent: {
        padding: '8px 60px 0px 60px',
    },
    listConent: {
        height: '370px',
        overflowY: 'auto',
        border: '1px solid black',
        '& :hover': {
            backgroundColor: '#e6f1ff',
        },
        '& .Mui-selected': {
            backgroundColor: '#fcebeb',
            border: '1px solid #e2b4e3'
        },
        '& .Mui-selected:hover': {
            backgroundColor: '#fcebeb',
            border: '1px solid #e2b4e3'
        },
        padding: '0px',
    },
    listItem: {
        display: 'flex',
        justifyContent: 'flex-start',
        height: '60px',
        cursor: 'pointer'
    },
    // "キャンセルする"ボタン
    cancel: {
        color: '#1a1a1a',
        border: '1px solid',
        borderRadius: '4px',
        backgroundColor: '#e0e0e0',
        borderColor: '#cbcbcb',
        '&:hover': {
            backgroundColor: '#c1d1eb',
            borderColor: '#999999',
        },
        minWidth: '180px',
    },
    // "入力内容を確認する"ボタン
    confirmButton: {
        color: '#ffffff',
        border: '1px solid',
        borderRadius: '4px',
        backgroundColor: '#3380cc',
        borderColor: '#3380cc',
        '&:hover': {
            backgroundColor: '#4596e6',
            borderColor: '#3380cc',
        },
        minWidth: '180px',
    },
    listText: {
        color: '#3380cc',
    },
}))

export interface OptionList {
    [key: string]: any
    value: string // 大学コード
    label: string // 学校名
    facultyCode: string // 学部コード
    subjectCode: string // 学科コード
    schoolGroupCode: string // 学校グループコード
}

export interface FiftyPhonogramData {
    [key: string]: any
    value: string
    label: string
    index: number
}

interface Props {
    schoolNameSelectDialog: boolean
    setSchoolNameSelectDialog: (state: boolean) => void
    setFiftyPhonogramDialog: (state: boolean) => void
    optionList: OptionList[]
    getSchoolNameSelectData: (values: OptionList) => void
    setFiftyPhonogramData: (values: FiftyPhonogramData) => void
}

const SchoolNameSelect = ({ schoolNameSelectDialog, setSchoolNameSelectDialog, setFiftyPhonogramDialog, optionList, getSchoolNameSelectData, setFiftyPhonogramData }: Props) => {
    const classes = useStyles()
    const [selectedData, setSelectedData] = useState<OptionList>({ label: magiContants.EMPTY, value: magiContants.EMPTY, facultyCode: magiContants.EMPTY, subjectCode: magiContants.EMPTY, schoolGroupCode: magiContants.EMPTY })
    const [selectedIndex, setSelectedIndex] = useState(-2)

    useEffect(() => {
        setSelectedIndex(-2)
    }, [optionList])

    const onLink = (data: OptionList, index: number) => {
        if(data.label === magiContants.NONE){
            let dataSelect: OptionList = {
                label: magiContants.NONE,
                value: magiContants.EMPTY,
                facultyCode: magiContants.EMPTY,
                subjectCode: magiContants.EMPTY,
                schoolGroupCode: magiContants.EMPTY,
            }
            setSelectedData(dataSelect)
            setSelectedIndex(-1)
        }else{
            let dataSelect: OptionList = {
                label: data.label,
                value: data.value,
                facultyCode: data.facultyCode,
                subjectCode: data.subjectCode,
                schoolGroupCode: data.schoolGroupCode
            }
            setSelectedData(dataSelect)
            setSelectedIndex(index)
        }
        let dataSelect: OptionList = {
            label: data.label,
            value: data.value,
            facultyCode: data.facultyCode,
            subjectCode: data.subjectCode,
            schoolGroupCode: data.schoolGroupCode
        }
        setSelectedData(dataSelect)
        setSelectedIndex(index)
    }

    const handleCancel = () => {
        setSchoolNameSelectDialog(false)
        setFiftyPhonogramDialog(true)
    }

    const handleConfirm = () => {
        setFiftyPhonogramData({ value: magiContants.EMPTY, label: magiContants.EMPTY, index: 0 })
        if (selectedIndex === -2) {
            setSchoolNameSelectDialog(false)
            setFiftyPhonogramDialog(false)
        } else {
            getSchoolNameSelectData(selectedData)
        }
    }

    return (
        <>
            {/* 学校名選択 */}
            <Dialog open={schoolNameSelectDialog} fullWidth maxWidth='md'>
                <DialogTitle className={classes.dialogTitle}>
                    <Grid className={classes.title}>学校名選択</Grid>
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <List component='div' className={classes.listConent}>
                        {optionList.map((data: OptionList, index: number) => (
                            <ListItem
                                selected={selectedIndex === index}
                                button
                                divider
                                className={classes.listItem}
                                onClick={() => {
                                    onLink(data, index)
                                }}>
                                <div className={classes.listText}>{data.label}</div>
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Grid container direction='row' justify='center'>
                        <Grid xs={5} item container justify='flex-end'>
                            <Button className={classes.cancel} onClick={handleCancel} variant='contained'>キャンセルする</Button>
                        </Grid>
                        <Grid style={{ width: '20px' }} />
                        <Grid xs={5} item>
                            <Button className={classes.confirmButton} onClick={handleConfirm} variant='contained'>OK</Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default SchoolNameSelect